
import { useState, FormEvent } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telefon: '',
    nachricht: '',
    service: ''
  });
  const [quoteData, setQuoteData] = useState({
    name: '',
    email: '',
    telefon: '',
    adresse: '',
    projektart: '',
    beschreibung: '',
    termin: ''
  });
  const [activeTab, setActiveTab] = useState('kontakt');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleContactSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3sk0ugavqn86fvnj7k0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend,
      });

      if (response.ok) {
        setSubmitMessage('Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet.');
        setFormData({ name: '', email: '', telefon: '', nachricht: '', service: '' });
      } else {
        setSubmitMessage('Es gab einen Fehler beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.');
      }
    } catch (error) {
      setSubmitMessage('Es gab einen Fehler beim Senden Ihrer Nachricht. Bitte versuchen Sie es erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleQuoteSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(quoteData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3sk0ugavqn86fvnj7kg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend,
      });

      if (response.ok) {
        setSubmitMessage('Vielen Dank! Ihre Kostenvoranschlag-Anfrage wurde erfolgreich gesendet.');
        setQuoteData({ name: '', email: '', telefon: '', adresse: '', projektart: '', beschreibung: '', termin: '' });
      } else {
        setSubmitMessage('Es gab einen Fehler beim Senden Ihrer Anfrage. Bitte versuchen Sie es erneut.');
      }
    } catch (error) {
      setSubmitMessage('Es gab einen Fehler beim Senden Ihrer Anfrage. Bitte versuchen Sie es erneut.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Kontakt & Kostenvoranschlag
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Haben Sie Fragen oder benötigen Sie einen Kostenvoranschlag? 
            Kontaktieren Sie uns - wir beraten Sie gerne!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold mb-6">Kontaktinformationen</h3>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-user-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">Inhaberin</h4>
                  <p className="text-gray-300">Nancy Born</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">Telefon</h4>
                  <p className="text-gray-300">Büro: 0175 / 7 44 30 33</p>
                  <p className="text-gray-300">Außendienst: 0160 / 117 29 60</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">E-Mail</h4>
                  <p className="text-gray-300">info.joallround@gmail.com</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">Außendienstsitz</h4>
                  <p className="text-gray-300">Kiefernweg 1, 16831 Rheinsberg</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mr-4 flex-shrink-0">
                  <i className="ri-building-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">Bürostandort</h4>
                  <p className="text-gray-300">Heinrich-Heine-Str. 120, 38855 Wernigerode</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <h4 className="font-semibold mb-4 text-white">Standort Außendienstsitz</h4>
              <div className="rounded-lg overflow-hidden border border-gray-600">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2394.123456789!2d12.8987654321!3d53.0987654321!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sKiefernweg%201%2C%2016831%20Rheinsberg!5e0!3m2!1sde!2sde!4v1234567890123!5m2!1sde!2sde"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Standort Außendienstsitz - Kiefernweg 1, 16831 Rheinsberg"
                ></iframe>
              </div>
            </div>
          </div>

          <div>
            <div className="mb-6">
              <div className="flex border-b border-gray-700">
                <button
                  onClick={() => setActiveTab('kontakt')}
                  className={`px-6 py-3 font-semibold transition-colors duration-200 cursor-pointer ${
                    activeTab === 'kontakt' 
                      ? 'border-b-2 border-blue-500 text-blue-400' 
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  Kontakt
                </button>
                <button
                  onClick={() => setActiveTab('kostenvoranschlag')}
                  className={`px-6 py-3 font-semibold transition-colors duration-200 cursor-pointer ${
                    activeTab === 'kostenvoranschlag' 
                      ? 'border-b-2 border-blue-500 text-blue-400' 
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  Kostenvoranschlag
                </button>
              </div>
            </div>

            {submitMessage && (
              <div className={`mb-6 p-4 rounded-lg ${
                submitMessage.includes('erfolgreich') 
                  ? 'bg-green-600 text-white' 
                  : 'bg-red-600 text-white'
              }`}>
                {submitMessage}
              </div>
            )}

            {activeTab === 'kontakt' && (
              <form onSubmit={handleContactSubmit} data-readdy-form id="kontakt">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium mb-2">
                      E-Mail *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="telefon" className="block text-sm font-medium mb-2">
                      Telefon
                    </label>
                    <input
                      type="tel"
                      id="telefon"
                      name="telefon"
                      value={formData.telefon}
                      onChange={(e) => setFormData({...formData, telefon: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="service" className="block text-sm font-medium mb-2">
                      Service
                    </label>
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={(e) => setFormData({...formData, service: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    >
                      <option value="">Bitte wählen...</option>
                      <option value="Beratung">Beratung</option>
                      <option value="Kostenvoranschlag">Kostenvoranschlag</option>
                      <option value="Sonstiges">Sonstiges</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="nachricht" className="block text-sm font-medium mb-2">
                      Nachricht
                    </label>
                    <textarea
                      id="nachricht"
                      name="nachricht"
                      rows={4}
                      value={formData.nachricht}
                      onChange={(e) => setFormData({...formData, nachricht: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    ></textarea>
                  </div>
                  
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
                  >
                    {isSubmitting ? 'Senden...' : 'Nachricht senden'}
                  </Button>
                </div>
              </form>
            )}

            {activeTab === 'kostenvoranschlag' && (
              <form onSubmit={handleQuoteSubmit} data-readdy-form id="kostenvoranschlag">
                <div className="space-y-6">
                  <div>
                    <label htmlFor="quote-name" className="block text-sm font-medium mb-2">
                      Name *
                    </label>
                    <input
                      type="text"
                      id="quote-name"
                      name="name"
                      value={quoteData.name}
                      onChange={(e) => setQuoteData({...quoteData, name: e.target.value})}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="quote-email" className="block text-sm font-medium mb-2">
                      E-Mail *
                    </label>
                    <input
                      type="email"
                      id="quote-email"
                      name="email"
                      value={quoteData.email}
                      onChange={(e) => setQuoteData({...quoteData, email: e.target.value})}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="quote-telefon" className="block text-sm font-medium mb-2">
                      Telefon *
                    </label>
                    <input
                      type="tel"
                      id="quote-telefon"
                      name="telefon"
                      value={quoteData.telefon}
                      onChange={(e) => setQuoteData({...quoteData, telefon: e.target.value})}
                      required
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="adresse" className="block text-sm font-medium mb-2">
                      Adresse
                    </label>
                    <input
                      type="text"
                      id="adresse"
                      name="adresse"
                      value={quoteData.adresse}
                      onChange={(e) => setQuoteData({...quoteData, adresse: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-white"
                    />
                  </div>
                  
                  <div>
                    <label htmlFor="projektart" className="block text-sm font-medium mb-2">
                      Art des Projekts
                    </label>
                    <select
                      id="projektart"
                      name="projektart"
                      value={quoteData.projektart}
                      onChange={(e) => setQuoteData({...quoteData, projektart: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-white"
                    >
                      <option value="">Bitte wählen...</option>
                      <option value="Schilder">Schilder</option>
                      <option value="Folierung">Folierung</option>
                      <option value="Beschilderung">Beschilderung</option>
                      <option value="Sonstiges">Sonstiges</option>
                    </select>
                  </div>
                  
                  <div>
                    <label htmlFor="beschreibung" className="block text-sm font-medium mb-2">
                      Projektbeschreibung
                    </label>
                    <textarea
                      id="beschreibung"
                      name="beschreibung"
                      rows={4}
                      value={quoteData.beschreibung}
                      onChange={(e) => setQuoteData({...quoteData, beschreibung: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-white"
                    ></textarea>
                  </div>
                  
                  <div>
                    <label htmlFor="termin" className="block text-sm font-medium mb-2">
                      Gewünschter Termin
                    </label>
                    <input
                      type="text"
                      id="termin"
                      name="termin"
                      value={quoteData.termin}
                      onChange={(e) => setQuoteData({...quoteData, termin: e.target.value})}
                      className="w-full px-4 py-3 bg-gray-800 border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus-border-transparent text-white"
                    />
                  </div>
                  
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
                  >
                    {isSubmitting ? 'Senden...' : 'Kostenvoranschlag anfordern'}
                  </Button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
